import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Badge, Button, Col, Container, Dropdown, Row, Table, Modal } from 'react-bootstrap';
import DynamicBreadcrumb from '../header/breadcrumb';
import { Link } from "react-router-dom";
import offerAPI from "../../services/offerapi";
import moment from "moment";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import $ from "jquery";
import "bootstrap-datepicker";
import { showConfirm } from "react-confirm-prompt";
import branchApi from "../../services/branchapi";
import { Switch } from "@mui/material";
import BranchesModal from "./BranchesModal";


const Discount = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [totalOffer, setTotalOffer] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 15,
    });
    const [sortModel, setSortModel] = useState([
        { field: 'id', sort: 'desc' },
    ]);
    const [refreshTable, setRefreshTable] = useState(false);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [offerTypeFilter, setOfferTypeFilter] = useState(null);
    const [createdDateFilter, setCreatedDateFilter] = useState({ start: null, end: null });
    const [branches, setBranches] = useState([]);
    const [branchesModalVisible, setBranchesModalVisible] = useState(false);
    const [availableBranches, setAvailableBranches] = useState([]);
    const pathArray = useMemo(() => [{ name: "Discount Offers List", url: null }], []);
    const [selectedOfferId, setSelectedOfferId] = useState(null);
    const offerTypes = useMemo(() => ({
        1: "Cart Value",
        2: "Product Total Value",
        3: "Discount Offer",
        4: "Buy and get Offer",
        5: "Free Product Offer",
    }), []);
    const statusArr = useMemo(() => ({
        1: "Active",
        2: "Inactive"
    }), []);
    const statusColors = useMemo(() => ({
        0: "secondary",
        1: "success",
        2: "danger",
    }), []);

    const fetchOffers = useCallback(async () => {
        setLoading(true);
        try {
            const { page, pageSize } = paginationModel;
            const data = await offerAPI.getAllOffers({
                limit: pageSize,
                page,
                sortModel,
                filterModel: {
                    ...filterModel,
                    offerType: offerTypeFilter,
                    createdDate: createdDateFilter,
                },
            });

            const formattedRows = data.data.result.map((cust, index) => {
                const offerTypeName = offerTypes[cust.offer_type] || "Others";

                return {
                    id: cust.id,
                    sno: index + 1,
                    created_at: moment(cust.created_at).format("YYYY/MM/DD kk:mm:ss"),
                    offer_start_date: moment(cust.offer_start_date).format("YYYY/MM/DD kk:mm:ss"),
                    offer_end_date: moment(cust.offer_end_date).format("YYYY/MM/DD kk:mm:ss"),
                    offer_name: cust.offer_name,
                    offerType: offerTypeName,
                    offer_type: cust.offer_type,
                    status: cust.status,
                    offerBranches: cust.offerBranches || [],
                    productCount: cust.productCount || 0,
                };
            });

            setRows(formattedRows);
            setTotalOffer(data.data.totalRecords[0].total_records || 0);
        } catch (error) {
            console.error("Failed to fetch Contacts:", error);
        } finally {
            setLoading(false);
        }
    }, [paginationModel, sortModel, filterModel, offerTypeFilter, offerTypes, statusArr, refreshTable]);

    useEffect(() => {
        fetchOffers();
    }, [fetchOffers]);
    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const response = await branchApi.getAllBranches({
                    limit: 200,
                    page: 0,
                    status: 1, // You can modify this depending on your requirements
                    sortModel: [{ field: "branchName", sort: "asc" }],
                    filterModel: [],
                });
                setBranches(response.data.result); // Assuming the branches are in result
            } catch (error) {
                console.error("Failed to fetch branches:", error);
            }
        };

        fetchBranches();
    }, []);

    const handleStatusClick = (offerId, currentStatus) => {
        const title =
            currentStatus === 9
                ? "Warning: This offer confirmation will be deleted and cannot be reverted."
                : currentStatus === 1
                    ? "Are you sure you want to set this offer to inactive?"
                    : "Are you sure you want to set this offer to active?";

        const description =
            currentStatus === 9
                ? "This action is irreversible."
                : currentStatus === 1
                    ? "This will inactivate the offer"
                    : "This will activate the offer";

        const type = currentStatus === 9 ? "warning" : "info";

        showConfirm(title, {
            description,
            type,
            confirmText: currentStatus === 9 ? "Delete" : "Confirm",
            cancelText: "Cancel",
        }).then(answer => {
            if (answer) submitUpdateDetails(offerId, currentStatus);
        });
    };

    const columns = useMemo(() => [
        { field: "sno", headerName: "S NO", sortable: false },
        { field: "created_at", headerName: "Created ON", flex: 1 },
        { field: "offer_name", headerName: "Offer Name", flex: 1 },
        { field: "offerType", headerName: "Offer Type", flex: 1 },
        { field: "offer_start_date", headerName: "Start ON", flex: 1 },
        { field: "offer_end_date", headerName: "End ON", flex: 1 },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                const statusColor = statusColors[status] || "secondary";
                const statusName = statusArr[status] || "Pending";
                // Double click triggers status toggle confirmation
                const onDoubleClick = () => {
                    handleStatusClick(params.row.id, status);
                };

                return (
                    <Badge
                        pill
                        bg={statusColor}
                        style={{ cursor: 'pointer' }}
                        onDoubleClick={onDoubleClick}
                        title="Double click to toggle status"
                    >
                        {statusName}
                    </Badge>
                );
            }
        },
        {
            field: "branches",
            headerName: "Branches",
            flex: 1,
            renderCell: (params) => (
                <Button
                    variant="btn btn-warning text-white p-2"
                    onClick={() => handleOpenBranchesModal(params.row)}
                >
                    View Branches
                </Button>
            ),
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const productCount = params.row.productCount || 0;
                const offerTypeId = params.row.offer_type;

                if (offerTypeId === 4 || offerTypeId === 5) {
                    return (
                        <Link
                            to={`/admin/offers/manual/edit/${params.row.id}`}
                            className="btn btn-primary text-white"
                            title="Edit Offer"
                        >
                            Edit
                        </Link>
                    );
                }

                if (productCount > 0) {
                    return (
                        <Link to={`/offers/details/${params.row.id}`} className="btn btn-primary">
                            View
                        </Link>
                    );
                } else {
                    return (
                        <button
                            className="btn btn-danger"
                            onClick={() => handleDeleteOffer(params.row.id)}
                        >
                            Delete
                        </button>
                    );
                }
            },
        },
    ], []);


    const submitUpdateDetails = async (offerId, currentStatus) => {
        try {
            // Toggle status: if active (1), set to inactive (2), else active (1)
            let sendStatus;
            if (currentStatus === 1) {
                sendStatus = 2;
            } else if (currentStatus === 2) {
                sendStatus = 1;
            } else if (currentStatus === 9) {
                sendStatus = 9; // no change
            } else {
                sendStatus = currentStatus; // fallback, just in case
            }


            const params = {
                action: "status",
                status: sendStatus,
                offerId: offerId,
                reason: null, // pass notes if you want
            };

            const resp = await offerAPI.updateOfferStatus(params);

            if (resp) {
                const message = resp.message || "Branch status updated successfully";
                await showConfirm("Success", {
                    description: message,
                    type: "success",
                    hideCancel: true,
                });
                setRefreshTable((prev) => !prev);
            } else {
                await showConfirm("Oops!", {
                    description: "Process failed, kindly try again later!",
                    type: "warning",
                    hideCancel: true,
                });
            }
        } catch (error) {
            await showConfirm("Oops!", {
                description: "Process failed, kindly try again later!",
                type: "warning",
                hideCancel: true,
            });
        }
    };


    const handleDateChange = (value, type) => {
        if (type === "start") {
            setCreatedDateFilter((prev) => ({ ...prev, start: value }));
        } else if (type === "end") {
            setCreatedDateFilter((prev) => ({ ...prev, end: value }));
        }
    };


    const applyFilters = () => {
        // console.log(createdDateFilter, 'createdDateFilter');
        setFilterModel({
            items: [
                { columnField: 'createdAt', operatorValue: 'isAfter', value: createdDateFilter.start },
                { columnField: 'createdAt', operatorValue: 'isBefore', value: createdDateFilter.end },
                { columnField: 'offerType', operatorValue: 'equals', value: offerTypeFilter },
            ],
        });
    };

    const resetFilters = () => {
        setOfferTypeFilter(null);
        setCreatedDateFilter({ start: null, end: null });
        setFilterModel({ items: [] });
        $("#startDate").datepicker("clearDates");
        $("#endDate").datepicker("clearDates");
    };

    useEffect(() => {
        // Initialize the start date picker
        $("#startDate").datepicker({
            format: "yyyy-mm-dd",
            clearBtn: true,
            autoclose: true,
            todayHighlight: true,
            endDate: "today", // Disable future dates for the start date
        }).on("changeDate", (e) => {
            // When the start date changes, update the state
            setCreatedDateFilter((prevState) => ({
                ...prevState,
                start: e.format("yyyy-mm-dd"),
            }));

            // Set the start date for the end date picker
            $("#endDate").datepicker("setStartDate", e.date);
        });

        // Initialize the end date picker
        $("#endDate").datepicker({
            format: "yyyy-mm-dd",
            clearBtn: true,
            autoclose: true,
            todayHighlight: true,
            startDate: "+0d",
            endDate: "today", // Ensure that end date cannot be before start date
        }).on("changeDate", (e) => {
            // When the end date changes, update the state
            setCreatedDateFilter((prevState) => ({
                ...prevState,
                end: e.format("yyyy-mm-dd"),
            }));
        });

        // Clean up datepickers on component unmount
        return () => {
            $("#startDate").datepicker("destroy");
            $("#endDate").datepicker("destroy");
        };
    }, []);


    const handleOpenBranchesModal = (rowsRecord) => {
        // console.log(rowsRecord, 'rowsRecord');
        const { id: offerId, offerBranches } = rowsRecord; // Assuming offerId is part of the row data
        setBranchesModalVisible(true);
        setSelectedOfferId(offerId); // This can be used to fetch branches specific to the offer if needed
        setAvailableBranches(offerBranches); // Assuming offerBranches is an array of branch objects
    };

    const handleCloseBranchesModal = () => {
        setBranchesModalVisible(false);
    };

    const handleToggleBranchStatus = (branchId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 2 : 1; // Assuming 1 is active and 2 is inactive
        // Make the API call to update the branch status here
        // For now, let's assume you directly toggle the status on the frontend
        setBranches((prevState) =>
            prevState.map((branch) =>
                branch.id === branchId ? { ...branch, status: newStatus } : branch
            )
        );
    };

    const handleDeleteOffer = (offerId) => {
        handleStatusClick(offerId, 9);
    };
    return (
        <Container>
            <DynamicBreadcrumb pathArray={pathArray} />
            <Row className="mb-4">
                <Col md={4} className="d-flex align-items-center">
                    <h5 className="mb-0">All Discount Product Items List</h5>
                </Col>

                <Col md={8}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "12px",
                            flexWrap: "nowrap",
                        }}
                    >
                        <Link
                            to="/admin/offers/discount/create"
                            className="btn btn-info text-white"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                maxWidth: "220px",
                                height: "48px",
                                whiteSpace: "nowrap",
                                flex: "0 0 auto",
                                textDecoration: "none",
                            }}
                        >
                            Upload Discount Offer
                        </Link>

                        <Link
                            to="/admin/offers/manual/create"
                            className="btn btn-info text-white"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                maxWidth: "220px",
                                height: "48px",
                                whiteSpace: "nowrap",
                                flex: "0 0 auto",
                                textDecoration: "none",
                            }}
                        >
                            Create Buy & Get Offer
                        </Link>
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col sm={3}>
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            Offer Type: {offerTypes[offerTypeFilter] || "All"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setOfferTypeFilter(null)}>
                                All
                            </Dropdown.Item>
                            {Object.keys(offerTypes).map((key) => (
                                <Dropdown.Item key={key} onClick={() => setOfferTypeFilter(parseInt(key))}>
                                    {offerTypes[key]}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col sm={2}>
                    <input
                        id="startDate"
                        type="text"
                        className="form-control"
                        placeholder="Start Date"
                        onChange={(e) => handleDateChange(e.target.value, "start")}
                    />
                </Col>
                <Col sm={2}>
                    <input
                        id="endDate"
                        type="text"
                        className="form-control"
                        placeholder="End Date"
                        onChange={(e) => handleDateChange(e.target.value, "end")}
                    />
                </Col>
                <Col sm={4} className="d-flex justify-content-between">
                    <Button className="ms-1" variant="primary" onClick={applyFilters}>
                        Apply Filters
                    </Button>
                    <Button className="ms-1" variant="secondary" onClick={resetFilters}>
                        Reset Filters
                    </Button>
                </Col>
            </Row>
            <Row className="mt-2">
                <Box>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        getRowHeight={() => "3"}
                        rowsPerPageOptions={[5, 10, 20]}
                        paginationMode="server"
                        rowCount={totalOffer}
                        loading={loading}
                        disableRowSelectionOnClick
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        sortingMode="server"
                        filterMode="server"
                        onSortModelChange={setSortModel}
                        onFilterModelChange={setFilterModel}
                        autosizeOptions={{
                            columns: ["name", "offerType", "status"],
                            includeOutliers: true,
                            includeHeaders: false,
                        }}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                printOptions: { disableToolbarButton: true },
                                csvOptions: { disableToolbarButton: true },
                            },
                        }}
                        sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 0.5,
                            },
                        }}
                    />
                </Box>
            </Row>


            <BranchesModal
                branches={branches}
                availableBranches={availableBranches}
                branchesModalVisible={branchesModalVisible}
                handleCloseBranchesModal={handleCloseBranchesModal}
                selectedOfferId={selectedOfferId}
            />
        </Container>
    )
};

export default Discount
